export const MILLIGRAMS = 'MILLIGRAMS';
export const MILLILITERS = 'MILLILITERS';
export const GRAMS = 'GRAMS';
export const MILLIGRAMS_PER_GRAM = 1000;
export const MILLILITERS_PER_OZ = 29.5735;
export const GRAMS_PER_OUNCE = 28;
export const FLOWER_TYPES = ['Flower', 'Pre-Rolls'];
export const CONCENTRATE_TYPES = ['Concentrate', 'Vaporizers'];
export const EDIBLE_TYPES = ['Edible'];
export const TINCTURE_TYPES = ['Tincture'];
export const TOPICAL_TYPES = ['Topicals'];
export const WEIGHTED_TYPES = ['Flower', 'Pre-Rolls', 'Concentrate', 'Vaporizers'];
